<template>
  <div class="phonebg" v-if="isgly">
    <div class="jiudian">
      <div class="title">授权登录</div>
    </div>
    <div class="weixin">
      <div class="content">
        <div>
          <img class="face" :src="wxuser.headimgurl" />
        </div>
        <div class="name" v-html="wxuser.nickname"></div>
      </div>
    </div>
    <div class="weixin">
      <div class="title">申请登录信息</div>
      <div class="content">
        <div>
          <div class="titlecenter">
            <span class="fizeweight"></span>
            {{logininfo.hotelName}}
          </div>
          <div class="logininfo">
            <span class="fizeweight">申请人：</span>
            {{logininfo.name}} 【{{logininfo.userName}}】
          </div>
          <div class="logininfo">
            <span class="fizeweight">部门：</span>
            {{logininfo.department}}
          </div>
          <div class="logininfo">
            <span class="fizeweight">班次：</span>
            {{logininfo.shift}}
          </div>
          <div class="logininfo">
            <span class="fizeweight">有效期：</span>
            {{logininfo.end}}
          </div>
          <!-- <div class="logininfo">
            <span class="fizeweight">申请时间：</span>
            {{logininfo.applyTime}}
          </div> -->
          <div class="shenqingsj">{{logininfo.userName}} 于  {{logininfo.applyTime}} 提交了此申请</div>
        </div>
      </div>
     
      <!-- 加盟号   酒店名称   账号   部门名称  班次  有效期   申请时间  申请状态（默认是0 待审核 ） 授权时间  授权人账号   -->
      <div v-if="submitShow && logininfo.status == 0" class="qrbd" @click="shouquan(1);">确认授权</div>
      <div v-if="submitShow && logininfo.status == 0"  class="qxbd" @click="shouquan(2);">取消授权</div>
      <div v-if="!submitShow" class="shouquanmsg">{{shouquanMsg}}</div>
    </div>
     <div style="height:100px;"></div>
  </div>
</template>

<script>
import { getRequest,postRequest } from "@/api/api1.js";

export default {
  name: "welcome",
  data() {
    return {
      image_base: this.$store.state.api,
      wxuser: {
        // openid: "oxIGSt-OMGpAhbCPKxshFtfgP8ns",
        // nickname: "星星",
        // sex: 1,
        // language: "zh_CN",
        // city: "南京",
        // province: "江苏",
        // country: "中国",
        // headimgurl:
        //   "https://thirdwx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTKdiaoRgUBW4hcibV4KrpMj2iaNqibcDrN6ibux1I5vtgVxD2QmDjyNlRVsELc6vrRpJ5IONsp8nokZDKQ/132",
        
      },
      logininfo: {
      
      },
      isgly:false,
      submitShow:true,
      shouquanMsg:"",
    };
  },
  created() {
    if (this.$route.query.id == null || this.$route.query.id == "") {
      alert("未获取到需要绑定的组，请重新扫码！");
      return;
    }
    //this.getShowQuan();
    this.getCode();
  },
  mounted() {},
  methods: {
    getCode() {
      // 非静默授权，第一次有弹框
      const code = this.getUrlParam("code"); // 截取路径中的code，如果没有就去微信授权，如果已经获取到了就直接传code给后台获取openId
      const local = window.location.href;
      const APPID = "wxe85988fe337541a9"; // 企业微信
      if (code == null || code == "") {
        window.location.href =
          "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
          APPID +
          "&redirect_uri=" +
          encodeURIComponent(local) +
          "&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect";
      } else {
        this.getOpenId(code); //把code传给后台获取用户信息
      }
    },
    getUrlParam(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },

    getOpenId(code) {
      let loadingInstance = this.$loading({ text: "正在加载用户..." });
      let param = {
        code: code,
      };
      postRequest("/getwxuser", param).then((res) => {
        this.$nextTick(() => {
          loadingInstance.close();
        });
        if (res.status == 200) {
          this.wxuser = res.data;
          //获取酒店用户信息
          this.getShowQuan();
        } else {
          alert(res.message);
        }
      });
    },
    getShowQuan(){
      let loadingInstance = this.$loading({ text: "正在加载..." });
      getRequest("sysUserXcxLogin/selectLoginApplyInfo?id="+this.$route.query.id).then((res) => {
        this.$nextTick(() => {
          loadingInstance.close();
          if (res.status == 200) {
            this.logininfo = res.data;
            if(res.data.openId == this.wxuser.openid){
               this.isgly = true;
               if(res.data.status == 1){
                this.shouquanMsg = "已审核";
                this.submitShow = false;
              }
            }else{
              alert("抱歉您不是此组的管理员,无权进行授权登录");
              this.$router.push(
                "/guanzhu?message=请使用已经绑定过组管理员的微信进行授权！"
              );
            }
          } else {
            alert(res.message);
          }
        });
      });
    },

    shouquan(status) {
      let loadingInstance = this.$loading({ text: "正在授权..." });
      getRequest("sysUserXcxLogin/verifyLoginApply?id="+this.$route.query.id+"&status="+status).then((res) => {
        this.$nextTick(() => {
          loadingInstance.close();
          if (res.status == 200) {
            // this.isgly = false;
            this.submitShow = false;
            
            if(status == 1){
              //alert("授权登录成功")
              this.shouquanMsg = "授权登录成功";
              // this.$router.push(
              //   "/guanzhu?message=授权登录成功！"
              // );
            }else{
              this.shouquanMsg = "您已取消授权";
              //alert("已取消授权")
              // this.$router.push(
              //   "/guanzhu?message=取消授权成功！"
              // );
            }
          } else {
            alert(res.message);
          }
        });
      });
    },
  },
};
</script>
<style scoped>
.shenqingsj{
  color:#999;
  font-size: 12px;
  color: red;
}
.shouquanmsg{
      color: red;
    font-size: 20px;
    font-weight: bold;
    width: 100%;
    text-align: center;
    margin-top: 2em;
}
.app-router{
      overflow-y: auto;
}
.fizeweight {
  font-size: 14px;
  width: 80px;
  display: block;
  text-align: right;
   font-weight:500;
}
.phonebg {
  background: linear-gradient(0deg, #d6ebff 0%, #e9f4ff 48%, #d6ebff 100%);
  /* background: linear-gradient(180deg, #D6EBFF, #E9F4FF 48%, #D6EBFF); */
}
.jiudian {
  box-shadow: 8px 8px 20px #b9ccec, -8px -8px 15px #ffffff;
}
.title {
  text-align: center;
  font-weight: bold;
  font-size: 1.2rem;
  height: 3rem;
  line-height: 3rem;
}
.content {
  border-radius: 8px;
  margin: 0% 3%;
  line-height: 2rem;
  padding: 5%;
  color: #575f6b;
  font-size: 1rem;
  box-shadow: 8px 8px 20px #b9ccec, -8px -8px 15px #ffffff;
  /* box-shadow: 8px 8px 20px #b9ccec inset, -8px -8px 15px #ffffff inset; */
  text-align: center;
}
.titlecenter {
  width: 100%;
  text-align: center;
  font-weight: bold;
}
.logininfo {
  display: flex;
  font-weight: bold;
}

.weixin,
.user {
  margin-top: 1rem;
  position: relative;
}
.name {
  font-weight: bold;
  font-size: 1.2rem;
}

.face {
  width: 4rem;
  border-radius: 100%;
}
.contentuser {
  display: flex;
  border-radius: 8px;
  margin: 0% 3%;
  line-height: 2rem;
  padding: 3%;
  color: #575f6b;
  font-size: 1rem;
  box-shadow: 8px 8px 20px #b9ccec, -8px -8px 15px #ffffff;
}
.divface {
  margin-right: 3%;
}
.faceuser {
  width: 4rem;
  height: 5rem;
  margin-top: 6%;
}

.qrbd {
  width: 50%;
  color: #4bb0ff;
  text-align: center;
  border-radius: 0.2em;
  box-shadow: 5px 5px 20px #a2b3dc, -5px -5px 20px #ffffff;
  left: 25%;
  bottom:12%;
  height: 2rem;
  line-height: 2rem;
  position: fixed;
  z-index: 999;
}
.qxbd {
  width: 50%;
 
  text-align: center;
  left: 25%;
  bottom:3%;
  height: 2rem;
  line-height: 2rem;
  position: fixed;
  z-index: 999;
}


</style>